var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyToClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.96706 9.95444C1.04505 10.8481 1.74227 11.5775 2.64246 11.6475C4.41841 11.7856 6.08159 11.7856 7.85754 11.6475C8.75773 11.5775 9.45495 10.8481 9.532 9.95444C9.63912 8.71846 9.75 7.43863 9.75 6.12616C9.75 4.81369 9.63912 3.53294 9.532 2.29789C9.45495 1.40425 8.75773 0.67479 7.85754 0.604829C6.12197 0.466441 4.37803 0.466441 2.64246 0.604829C1.74227 0.675723 1.04505 1.40425 0.96706 2.29789C0.861819 3.53387 0.75 4.81369 0.75 6.12616C0.75 7.43863 0.860879 8.71939 0.96706 9.95444V9.95444Z",
    stroke: "#103046"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7499 4.88892C13.0483 5.19211 13.2433 5.59934 13.282 6.04794C13.3891 7.28299 13.5 8.56374 13.5 9.87621C13.5 11.1887 13.3891 12.4685 13.282 13.7045C13.2049 14.5981 12.5077 15.3276 11.6075 15.3975C9.83158 15.5356 8.16839 15.5356 6.39245 15.3975C5.89042 15.3585 5.45152 15.1144 5.14795 14.7511",
    stroke: "#103046",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyToClipboard);
export default __webpack_public_path__ + "static/media/copy-to-clipboard.58bb30dff8f2f939280f22eead03ad1d.svg";
export { ForwardRef as ReactComponent };